import React from "react";
import {Accordion} from "react-bootstrap";
import '../css/FAQ.css'

const FAQ=()=>{
    return(
        <div className={'flex__center'}>
            <div className={"contents-title-background-box"}>
                <div className={'red-dot-box'}>
                    <div className={'red-dot'}/>
                </div>
                <h3>FAQ</h3>
            </div>
                <Accordion defaultActiveKey="0" className={'accordion-box'}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><b>Q&ensp;</b>매장 위치가 어디인가요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b> 제주시 용남 1길 16 1층, 제주앙 미래컨벤션 센터 뒷 골목입니다.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header><b>Q&ensp;</b>주차 가능한가요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b> 매장 도보 3분 거리에 있는 공용주차장을 이용하시면 가능합니다.<br/> 제주특별자치도 제주시 용담일동 2578-3
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header><b>Q&ensp;</b>주문 방법을 알고 싶어요.</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b> 제주앙 홈페이지 또는 카카오톡 오픈채팅을 이용하시면 쉽게 주문이 가능합니다.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header><b>Q&ensp;</b>주문 변경 or 취소는 어떻게 하나요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b> 매장으로 전화 주시면 도와드리겠습니다.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header><b>Q&ensp;</b>결제 수단은 어떤 것들이 있나요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b> 홈페이지를 통해 계좌이체가 가능하고, 카드결제 필요시 계좌이체로 결제 후 매장 픽업시 변경 도와드리겠습니다.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header><b>Q&ensp;</b>환불 규정이 어떻게 되나요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b>픽업일 기준 24시간 전 100% 환불 가능하고, 픽업 당일은 환불이 불가합니다
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Header><b>Q&ensp;</b>떡을 다음날 먹을경우에는 어떻게하면되나요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b>방부처리 없이 수제로 만든 제품이기 때문에 가능한 빨리 드시는 게 좋으나,<br/>
                            보관 필요시 앙금과 떡을 분리하여 떡은 냉동에 앙금은 냉장에 보관하시고,<br/>
                            드시기전 떡만 상온에서 해동 후 앙금과 같이 드실수있습니다.<br/>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                        <Accordion.Header><b>Q&ensp;</b>당일 주문 가능한가요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b> 영업시간 기준 최소 3시간 전 매장으로 연락 부탁드립니다.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="8">
                        <Accordion.Header><b>Q&ensp;</b>영업시간 내에 픽업못할 경우 어떻게 해야하나요?</Accordion.Header>
                        <Accordion.Body>
                            <b>A&ensp;</b>당일 픽업이 불가할시 매장으로 연락주세요.<br/>
                            다음날까지 보관은 가능하나, 품질이 저하 될 수 있습니다

                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
        </div>
    );
}

export default FAQ
